document.addEventListener('DOMContentLoaded', () => {
    const headerWrapper = document.querySelector('[data-js-header]');
    if (headerWrapper) {
        const navigation = new Navigation(headerWrapper);
        navigation.init();
    }
});

class Navigation {
    constructor(headerWrapper) {
        this.headerWrapper = headerWrapper;
        this.mobileMenuActive = false;
    }

    init() {
        this.mobileMenu = this.headerWrapper.querySelector('[data-js-mobile-menu]');
        this.mobileMenuBars = this.headerWrapper.querySelector('[data-js-icon-bars]');
        this.mobileMenuCross = this.headerWrapper.querySelector('[data-js-icon-cross]');
        this.mobileBurgerButton = this.headerWrapper.querySelector('[data-js-nav-button]');
        this.initEventListeners();
    }

    toggleMobileMenu(close = undefined) {
        if (close || this.mobileMenuActive) {
            this.mobileMenu.classList.remove('js-show-mobile-menu');
            this.mobileMenuCross.classList.add('hidden');
            this.mobileMenuBars.classList.remove('hidden');
            document.body.style.overflow = 'auto';
            this.mobileMenuActive = false;
        } else {
            this.mobileMenu.classList.add('js-show-mobile-menu');
            this.mobileMenuBars.classList.add('hidden');
            this.mobileMenuCross.classList.remove('hidden');
            document.body.style.overflow = 'hidden';
            this.mobileMenuActive = true;
        }
    }

    initEventListeners() {
        this.mobileBurgerButton.addEventListener('click', () => {
            this.toggleMobileMenu();
        });
    }
}
